import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { FileUploaded } from '../models/file-uploaded';
import { environment } from '../../environments/environment';

@Injectable()
export class FileUploadService {

  baseUrl = environment.fileServiceBaseUrl;

  constructor(private httpClient: HttpClient) { }

  get(id: string) {
    const url = `${this.baseUrl}files/${id}`;
    const headers = new HttpHeaders()
    .set('Accept', 'application/json');
    return this.httpClient.get<FileUploaded>(url, { headers });
  }

  getById(id: string) {
    const url = `${this.baseUrl}fileById/${id}`;
    const headers = new HttpHeaders().set('Accept', 'application/json');
    return this.httpClient.get<FileUploaded>(url, { headers });
  }

  delete(id: string) {
    return of({});
  }

  upload(file: File, description: string) {
    const url = `${this.baseUrl}files`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('description', description);
    const req = new HttpRequest('POST', url, formData, {
      headers: headers,
      reportProgress: true
    });
    return this.httpClient.request(req)
    .map((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          return {id: '', progress: 0};

        case HttpEventType.UploadProgress:
          return  {id: '', progress: Math.round(100 * event.loaded / event.total)};

        case HttpEventType.Response:
          return {id: event.body, progress: 100};

        default:
          return {id: '', progress: -1};
      }
    });
  }

   deleteImage(fileId:string) {
    const url = `${this.baseUrl}files/${fileId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.httpClient.delete<void>(url, { headers });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/file-upload.service.ts